import { render, staticRenderFns } from "./ApprovePwdCreateI140.vue?vue&type=template&id=dd67a240&"
import script from "./ApprovePwdCreateI140.vue?vue&type=script&lang=js&"
export * from "./ApprovePwdCreateI140.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports